// Reversible client feature flags. Flip a value back to true to restore.
//
// COMPARE_ENABLED: temporarily hides "Compare Branches" from client
// navigation and blocks the /compare route (redirecting to /reports) while the
// feature is paused. All implementation, comparison surveys, published FINDs
// and data remain intact — set this back to `true` to restore the feature.
export const COMPARE_ENABLED = false;
